import * as _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { useAppStore } from '../stores/AppStore';
import { useUserStore } from '../stores/UserStore';
import { USER_ROLES, USER_TYPE } from '../types/userTypings';
import { RestService } from './RestService';

export const loginUser = (data: any) => {
  return RestService.post('/auth/login', data).then((user: any) => {
    useUserStore.setState({
      UUID: user.data.uuid,
      UBUUID: user.data.businessUuid,
      UROLE: user.data.roles,
      UNAME: user.data.name,
      UIMAGE: user.data.image,
      TOKEN: user.data.token
    });
    return user.data;
  });
};

export const forgotPassword = (data: any) => {
  return RestService.post('/auth/forgot-password', data);
};

export const resetPassword = (data: any) => {
  return RestService.post('/auth/reset-password', data);
};

export const verifyAccount = (data: any) => {
  return RestService.post('/auth/verify', data);
};

export const changePassword = (data: any) => {
  return RestService.post('/auth/change-password', data);
};

export const signupUser = (data: any) => {
  const uuid = uuidv4();
  const user = _.assign(data, { uuid, businessUuid: uuid, type: USER_TYPE.COMPANY });
  return RestService.post('/auth/signup', user);
};

export const switchBusiness = (data: any) => {
  return RestService.post('/auth/switch', data).then((user: any) => {
    useUserStore.setState({
      UUID: user.data.uuid,
      UBUUID: user.data.businessUuid,
      UROLE: user.data.roles,
      UNAME: user.data.name,
      UIMAGE: user.data.image,
      TOKEN: user.data.token
    });
    return user.data;
  });
};

export const updatePushToken = async (pushToken: string) => {
  const userUuid = useUserStore.getState().UUID;
  const businessUuid = useUserStore.getState().UBUUID;
  const push = { userUuid, businessUuid, pushToken };
  return RestService.post('/push', push);
};

export const getPreferences = () => {
  const userUuid = useUserStore.getState().UUID;
  if (!userUuid) return;
  RestService.get(`/preferences`).then((response: any) => {
    useAppStore.setState({ ...response.data, isLoaded: true });
  });
};
